import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ConsentBanner.css';

const STORAGE_KEY = 'monolith-consent';

function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="consent-banner" role="dialog" aria-label="Cookie notice">
      <p>
        We use essential cookies to run the shop and remember your preferences.
        See our <Link to="/privacy">Privacy</Link> policy.
      </p>
      <button type="button" className="store-btn" onClick={accept}>
        Accept
      </button>
    </div>
  );
}

export default ConsentBanner;
